import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { FaPlus, FaTrashAlt } from 'react-icons/fa';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import '../App.css';
import environment from '../environments/environment';
import Pagination from '../Pagination';
import * as ActionType from '../redux/actiontypes/ActionType';
import PagerService from '../Services/PagerService';
import * as constants from '../Constants';
import DelectModalComponent from '../popUpModals/DelectModalComponent';
import { Loading } from 'react-loading-ui';

const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer,
        userDetails: state.usersReducer
    }
}

class UserSummary extends React.Component {
    constructor() {
        super();
        this.state = {
            show: false,
            usersList: [],
            pageSize: '',
            totalItems: '',
            //pager object
            pager: {},
            // paged items
            pagedItems: [],
            usersListCount: '',
            email: '',
            userRole: '',
            firstName: '',
            lastName: '',
            updateUser: false
        }
    }
    componentDidMount = async () => {
        if (this.props.userStatus.userName !== "") {
            this.setState({
                pageSize: this.toSetPagination(),
                userRole: this.props.userStatus.userRole,
            }, () => {
                this.setPage(1);
            })
        } else {
            this.setState({
                reDirect: '/',
            })
        }

    }

    changeValue = (e) => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value });
    }

    search = e => {
        e.preventDefault();
        this.setPage(1);
    }

    clear = e => {
        e.preventDefault();
        this.setState({
            ...this.state,
            firstName: '',
            lastName: '',
            email: ''
        }, () => {
            this.setPage(1);
        })
    }
    toSetPagination() {
        let pageSize = 0;
        if (localStorage.getItem("listingPageSize") != null &&
            localStorage.getItem("listingPageSize") !== undefined && localStorage.getItem("listingPageSize") !== '0') {
            let tempstr = localStorage.getItem("listingPageSize");
            pageSize = parseInt(tempstr);
        }
        else {
            pageSize = 5;
        }
        return pageSize;
    }

    onPageNoChanged = (pageNo) => {
        this.setPage(pageNo);
    }

    pageSizeChanged = (pageSize) => {
        this.setState({
            pageSize: pageSize
        }, () => {
            this.setPage(1);
            localStorage.setItem('listingPageSize', pageSize);
        })
    }

    setPage(page) {
        this.getAllUsersList(page, this.state.pageSize);
    }

    getAllUsersList(page, pageSize) {
        let UserSearchVO = {};
        UserSearchVO.firstName = this.state.firstName.trim();
        UserSearchVO.lastName = this.state.lastName.trim();
        UserSearchVO.isActive = constants.IS_ACTIVE_YES;
        UserSearchVO.mailId = this.state.email.trim();
        UserSearchVO.pageNo = -1;
        UserSearchVO.pageSize = -1;
        axios.post(environment.getUserCount, UserSearchVO).then(response => {
            if (response !== undefined || response !== null) {
                this.setState({
                    ...this.state,
                    usersListCount: response.data
                }, () => {
                    if (this.state.usersListCount !== 0) {
                        UserSearchVO.pageNo = page;
                        UserSearchVO.pageSize = pageSize;
                        axios.post(environment.getAllUserDetails, UserSearchVO)
                            .then(response => {
                                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                                    this.setState({
                                        ...this.state,
                                        usersList: response.data.userVOList
                                    }, () => {
                                        this.setState({
                                            ...this.state,
                                            pageSize: this.toSetPagination(),
                                            pager: PagerService.getPager(
                                                this.state.usersListCount,
                                                page,
                                                this.state.pageSize
                                            ),
                                            totalItems: this.state.usersListCount,
                                            pagedItems: this.state.usersList.slice(
                                                0,
                                                this.pageSize
                                            )
                                        });

                                    });
                                } else {
                                    toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER });
                                }
                            })
                            .catch((error) => {
                                toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
                            });
                    } else {
                        this.setState({
                            totalItems: 0,
                            pagedItems: []
                        });
                    }
                })

            } else {
                this.setState({
                    totalItems: 0
                });
            }
        }).catch((error) => {
            toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
        });
    }

    toNewUsers(event) {
        event.preventDefault();
        this.props.dispatch({
            type: ActionType.GET_USER_DETAILS, user: {}
        });
        this.setState({
            ...this.state,
            reDirect: '/userCreation'
        })
        //this.props.nextStep();
    }

    getUserDetails(event, email) {
        event.preventDefault();
        axios.get(environment.getUserDetails + email).then(response => {
            if (response !== undefined && response !== null) {
                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    //this.props.getUserDetails(response.data.userVOList[0]);
                    this.props.dispatch({
                        type: ActionType.GET_USER_DETAILS, user: response.data.userVOList[0]
                    });
                    this.setState({
                        ...this.state,
                        reDirect: '/userCreation'
                    })
                } else {
                    toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER });
                }

            }
        }).catch((error) => {
            toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
        });

    }
    /*Inactivate the User*/
    showModal(e, id) {
        e.preventDefault();
        this.setState({
            show: true,
            id: id
        });

    }
    removeUser() {
        Loading();
        this.setState({
            show: false
        }, () => {
        axios.post(environment.removeUser + this.state.id+"/remove/active/N?username="+this.props.userStatus.userName, null).then(response => {
            if (response !== undefined && response !== null) {
                if (response.data.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    toast.success(response.data.message, { position: toast.POSITION.TOP_CENTER });
                    this.setPage(1);
                    setTimeout(() => {
                        Loading();
                    });
                } else {
                    setTimeout(() => {
                        Loading();
                    });
                    toast.error(response.data.message, { position: toast.POSITION.TOP_CENTER });
                }
            }
        }).catch((error) => {
            setTimeout(() => {
                Loading();
            });
            toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
        });

    });
    }
    onCloseModal(){
        this.setState({
            show: false
        });
    }

    render() {
        if (this.state.reDirect) {
            return <Redirect to={this.state.reDirect}></Redirect>

        }
        return (
            <section style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                <div className="container mt-2 ">
                    <h4>Users Details</h4>
                    <div className="row mb15 mr-2" style={{ marginTop: ' 15px' }}>
                        <div className="col pl-0 pr-0">
                            <label className="col  ">First Name</label>&nbsp;
                            <input type="text" id="firstName" name="firstName" placeholder="First Name" value={this.state.firstName} onChange={this.changeValue}></input>
                        </div>

                        <div className="col pl-0 pr-0">
                            <label className="col  ">Last Name</label>&nbsp;
                            <input type="text" id="LastName" name="lastName" placeholder="Last Name" value={this.state.lastName} onChange={this.changeValue}></input>
                        </div>

                        <div className="col pl-0 pr-0">
                            <label className="col  ">User Email Id</label>&nbsp;
                            <input type="text" id="userID" name="email" placeholder="User Email Id" value={this.state.email} onChange={this.changeValue}></input>
                        </div>
                    </div>

                    <div className="row mb-2 mt-2">
                        <div className="col-md-6 mr-auto text-left">
                            <Link onClick={this.search}><span
                                className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Search</span></Link>
                            <Link onClick={this.clear}><span
                                className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Clear</span> </Link>

                        </div>

                        <div className="col-md-6 ml-auto " style={{ textAlign: 'right' }}>
                            {/* <Link ><span className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} > Download</span></Link> */}
                            <button className="btn btn-primary" onClick={(event) => { this.toNewUsers(event) }} style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >
                                <FaPlus className="mr-2" ></FaPlus> Users</button>
                        </div >
                    </div >

                    <div className="table-responsive dashboard ">
                        <table className="table table-bordered table-condensed table-striped table-hover table-sm"
                            id="table-dashboard">

                            <thead className="color">
                                <tr style={{ borderStyle: 'hidden' }}>
                                    <th >First Name </th>
                                    <th >Last Name </th>
                                    <th >Role</th>
                                    <th >User Email Id</th>
                                    <th >Supervisor</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody style={{ borderStyle: 'hidden' }}  >
                                {this.state.pagedItems != null && this.state.pagedItems.map((user, index) => (
                                    <tr key={user.userId}>
                                        <td><Link onClick={(event) => this.getUserDetails(event, user.mailId)}>{user.firstName}</Link></td>
                                        <td>{user.lastName}</td>
                                        <td>{user.roles[0].roleName}</td>
                                        <td>{user.mailId}</td>
                                        <td>{user.supervisorr === '' ? ("-") : (user.supervisorr)}</td>
                                        <td><Link><FaTrashAlt onClick={(event) => this.showModal(event, user.userId)} ></FaTrashAlt></Link></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {/* {(this.state.pagedItems === undefined || this.state.pagedItems === null) && <Spinner></Spinner>} */}
                    {this.state.totalItems === 0 && <p> No Records are Found.</p>}
                    {this.state.pagedItems !== undefined && this.state.totalItems > 5 && <Pagination pager={this.state.pager} setPage={this.onPageNoChanged} setPageSize={this.pageSizeChanged}></Pagination>}
                    <ToastContainer style={{ marginTop: '7%' }} />
                    <DelectModalComponent show={this.state.show} hideModal = {()=> this.onCloseModal()} deleteChanges = {()=> this.removeUser()}></DelectModalComponent>
                </div >
            </section >
        )
    }

}
export default connect(mapStateToProps)(UserSummary);